import { selectSelectedUser } from 'Root/modules/users/selectors';
import {
  filter,
  find,
  flow,
  keys,
  pull,
} from 'lodash/fp';
import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';

import { toDoListSchema } from './schema';

export const toDoListsSelector = state => state.toDoLists;

export const selectDenormalizedToDoLists = createSelector(
  [
    toDoListsSelector,
    state => state,
  ],
  (toDoLists, state) => denormalize(keys(toDoLists), [toDoListSchema], state),
);

export const selectSelectedToDoList = createSelector(
  [
    selectDenormalizedToDoLists,
    selectSelectedUser,
  ],
  (toDoLists, selectedUser) => flow(
    find({ selected: true, owner: selectedUser.id }),
  )(toDoLists),
);

export const selectNonMyFirstListToDoLists = createSelector(
  [
    selectDenormalizedToDoLists,
  ],
  filter({ isMyFirstList: false }),
);

export const selectMyFirstList = createSelector(
  [
    selectDenormalizedToDoLists,
  ],
  find({ isMyFirstList: true }),
);

export const selectNonSelectedToDoLists = createSelector(
  [
    selectDenormalizedToDoLists,
    selectSelectedToDoList,
  ],
  (toDoLists, selectedToDoList) => pull(selectedToDoList)(toDoLists),
);

export const selectMeetsFeedbackRequirements = createSelector(
  [
    selectMyFirstList,
    selectNonMyFirstListToDoLists,
  ],
  (myFirstList, nonMyFirstListToDoLists) => nonMyFirstListToDoLists.length >= 1 || myFirstList.toDos.length >= 5,
);
